/**
 * @fileoverview My Page target details query hook.
 * @description Wraps GET /sales/targets/{targetId} in a TanStack query, idle until there's a target
 * to show.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Anshul Rokde
 */

import { useQuery } from '@tanstack/react-query'

import { SALES_CRM_QUERY_KEYS } from '@/features/sales/constants/prospects-query-keys.constants'
import { getMyPageTargetDetails } from '@/features/sales/services/my-page-targets.service'

/**
 * @description Fetches one target in full.
 * @param {string | null} targetId - The target to fetch, or null to stay idle.
 * @returns {ReturnType<typeof useQuery>} The query (data is the target's details).
 */
export function useMyPageTargetDetails(targetId: string | null) {
  return useQuery({
    queryKey: SALES_CRM_QUERY_KEYS.myPageTarget(targetId ?? ''),
    queryFn: () => getMyPageTargetDetails(targetId ?? ''),
    enabled: targetId !== null,
  })
}
